import { Enquiry } from './vehicles/@types';

const ctb = 'CarTakeBack';
const motorway = 'Motorway Marketplace';
const tcbg = 'The Car Buying Group';

const CTB_AGE_LOWER_THRESHOLD = 28;
const CTB_MILEAGE_LOWER_THRESHOLD = 280_000;

export const BUYER_SLUGS = {
  ctb,
  motorway,
  tcbg,
} as const;

export const BUYER_SLUG_LOOKUP = {
  [ctb]: 'CarTakeBack',
  [motorway]: 'Marketplace',
  [tcbg]: 'The Car Buying Group',
} as const;

export const BUYER_ID_LOOKUP = {
  [ctb]: 7,
  [motorway]: 9,
  [tcbg]: 1,
} as const;

type ctbEligibilityProps = {
  enquiry?: Pick<Enquiry, 'mileage'>;
  marketplaceEligible?: {
    eligible: boolean;
    ineligibleBy: string | null;
  };
  year?: number;
}

export const INELIGIBLE_BY = {
  PRICE: 'price',
  PRICE_MINIMUM_THRESHOLD: 'belowPriceMinThreshold',
};

export const ctbEligibility = ({ enquiry, marketplaceEligible, year }: ctbEligibilityProps) => {
  // If ineligible due to price minimum threshold, return true
  if (marketplaceEligible?.ineligibleBy === INELIGIBLE_BY.PRICE_MINIMUM_THRESHOLD) {
    return true;
  }

  // If year is undefined, we cannot determine age of car, so return false
  if (!year) {
    return false;
  }

  const mileage = enquiry?.mileage ?? 0;
  const ageOfCar = new Date().getFullYear() - year;
  return ageOfCar >= CTB_AGE_LOWER_THRESHOLD && mileage > CTB_MILEAGE_LOWER_THRESHOLD;
};
